import React from 'react';
import { cn } from '../../../../lib/utils';
import { SypacText } from '@sypac/component-library-react';
import FormInput from './FormInput';

/** Zone column header: label + "from" (km) input. */
const ZoneHeader: React.FC<{
	index: number;
	label: string;
	formik: any;
	className?: string;
	editFormula: boolean;
}> = ({ index, label, formik, className = '', editFormula }) => {
	return (
		<div
			className={cn(
				'w-full flex flex-col items-center justify-center gap-[12px]',
				className,
			)}
		>
			<SypacText variant="body-regular-medium">
				<p className="h-[24px] text-gray-80 whitespace-nowrap">{label}</p>
			</SypacText>
			<FormInput
				name={`zones.distances[${index}].from`}
				placeholder="Enter value"
				className={cn(
					'w-full rounded-[8px] transition hover:bg-white focus:bg-white',
					index === 0 ? 'bg-[#FAFAFA]' : 'bg-[#E9F7F5]',
				)}
				formik={formik}
				readOnly={!editFormula}
			/>
		</div>
	);
};

export default ZoneHeader;
